import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

const PharmaSalesRetailerChart = ({ data }) => {
  const chartData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    const grouped = {};

    data.forEach((item) => {
      if (!item.billDate) return;

      const date = new Date(item.billDate).toLocaleDateString("en-CA");

      if (!grouped[date]) {
        grouped[date] = {
          name: date,
          total: 0,
          paid: 0,
          due: 0,
        };
      }

      const total = parseFloat(item.afterDiscount) || 0;
      const paid = parseFloat(item.paidAmount) || 0;
      const due = total - paid;

      grouped[date].total += total;
      grouped[date].paid += paid;
      grouped[date].due += due;
    });

    return Object.values(grouped).sort(
      (a, b) => new Date(a.name) - new Date(b.name)
    );
  }, [data]);

  if (!chartData.length) {
    return <p style={{ textAlign: "center" }}>No data available</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />

        <Line
          type="monotone"
          dataKey="total"
          stroke="#8884d8"
          name="Total Sales"
        />
        <Line
          type="monotone"
          dataKey="paid"
          stroke="#82ca9d"
          name="Paid Amount"
        />
        <Line
          type="monotone"
          dataKey="due"
          stroke="#ff7300"
          name="Due Amount"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default PharmaSalesRetailerChart;